//印尼
export default { 
 common: { 
    notshow: 'Jangan tampilkan hari ini',
 unit: 'USDT', 
 day: 'hari', 
 week: 'minggu', 
 save: 'simpan', 
 submit: 'hantar', 
 confirmtitle: 'pastikan untuk melaksanakan operasi', 
 confirm: 'pastikan', 
 reset: 'set semula', 
 refresh: 'muat semula', 
 copy: 'salin', 
 copysuccessful: 'salinan berjaya', 
 modify: 'ubah suai', 
 binding: 'mengikat', 
 finished: 'telah selesai', 
 canceled: 'telah dibatalkan', 
 cancel: 'batalkan', 
 all: 'semua', 
 back: 'kembali', 
 loading: 'sedang memuat...', 
 nomore: 'semua rekod', 
 errortxt: 'gagal memuat', 
 loosing: 'lepaskan untuk memuat semula...', 
 pulling: 'tarik untuk memuat semula...', 
 nodata: 'tidak ada rekod buat masa ini', 
 buy: 'beli', 
 buyup: 'beli naik', 
 buydown: 'beli turun', 
 sell: 'jual', 
 forserver: 'sila hubungi khidmat pelanggan', 
 total: 'jumlah', 
 status1: 'menunggu penyemaksaan', 
 status2: 'selesai', 
 status3: 'tidak lulus', 
 paytype1: 'TRC20', 
 paytype2: 'ERC20', 
 paytype3: 'telegraf', 
 }, 
 footer: { 
 home: 'laman utama', 
 market: 'kedai', 
 exchange: 'pertukaran mata wang kripto', 
 options: 'pilihan', 
 assets: 'aset', 
 change: 'pindah', 
 recharge: 'isi semula', 
 withdrawal: 'keluarkan', 
 }, 
 home: { 
 menu1: 'perdagangan pilihan', 
 menu1desc: 'sokongan BTC/USDT dll', 
 menu2: 'isi semula cepat', 
 menu3: 'keluarkan', 
 menu4: 'khidmat pelanggan dalam talian', 
 menu5: 'pertukaran segera', 
 menu6: 'pinjaman bantu', 
 menu7: 'penambitan penjara untuk menambang', 
 menu8: 'jaminan', 
 menu9: 'pemindahan akaun', 
 ranktitle: 'senarai kenaikan', 
 name: 'nama', 
 price: 'harga terkini', 
 risefall: 'jumlah kenaikan/penurunan', 
 }, 
 register: { 
 register: 'daftar', 
 login: 'log masuk', 
 email: 'E-mel', 
 phone: 'no telefon', 
 accountplaceholder: 'sila masukkan akaun', 
 emailplaceholder: 'sila masukkan e-mel', 
 phoneplaceholder: 'sila masukkan no telefon', 
 pwdplaceholder: 'sila masukkan kata laluan', 
 pwdplaceholder1: 'kata laluan terdiri daripada 6-20 aksara atau nombor', 
 agepwdplaceholder: 'sila masukkan kata laluan sekali lagi', 
 agepwdplaceholder1: 'kedua-dua kata laluan tidak sama', 
 invitecodeplaceholder: 'sila masukkan kod jemputan', 
 remember: 'ingat kata laluan', 
 fotget: 'lupa kata laluan' 
 }, 
 market: { 
 title: 'kedai', 
 all: 'semua' 
 }, 
 member: { 
 reputation: 'skor kredibiliti', 
 identity_authentication: 'pengesahan identiti', 
 under_review: 'sedang disemak', 
 certified: 'telah disahkan', 
 awaiting_certification: 'menunggu pengesahan', 
 binding_withdrawal_address: 'mengikat alamat pengeluaran', 
 currently_selected_currency: 'mata wang yang dipilih sekarang', 
 withdrawal_address: 'alamat pengeluaran', 
 sharing_link: 'pautan perkongsian saya', 
 my_promotion_code: 'kod promosi saya', 
 promotion_code: 'kod promosi', 
 system_message: 'mesej sistem', 
 night_mode: 'mod malam', 
 security_center: 'pusat keselamatan', 
 seted: 'telah diset', 
 noset: 'belum diset', 
 login_password: 'kata laluan log masuk', 
 transaction_password: 'kata laluan pengeluaran', 
 app_download: 'muat turun aplikasi', 
 log_out: 'log keluar', 
 aboutus: 'pengenalan laman web' 
 }, 
 identity: { 
 title: 'pengesahan identiti', 
 name: 'nama', 
 nameplaceholder: 'sila masukkan nama sebenar', 
 uploader: 'muat naik gambar IC', 
 tip1: 'muat naik gambar hadapan IC', 
 tip2: 'muat naik gambar belakang IC' 
 }, 
 address: { 
 title: 'mengikat alamat pengeluaran', 
 bType: 'mata wang yang dipilih sekarang', 
 address: 'alamat pengeluaran', 
 addressplaceholder: 'sila masukkan alamat pengeluaran', 
 }, 
 security: { 
 title: 'pusat keselamatan', 
 modifypwd: 'kata laluan log masuk', 
 resetlegalpwd: 'kata laluan pengurusan', 
 loginpwd: 'kata laluan log masuk baru', 
 pwdage: 'sahkan kata laluan', 
 loginpwdplaceholder: 'sila masukkan kata laluan log masuk semasa', 
 loginnewpwdplaceholder: 'sila masukkan kata laluan log masuk baru', 
 moneypwd: 'sila masukkan kata laluan pengeluaran', 
 pwdageplaceholder: 'sila masukkan kata laluan sekali lagi' 
 }, 
 trade: { 
 title: 'pertukaran mata wang kripto', 
 price: 'harga', 
 num: 'kuantiti', 
 entrust: 'perintah semasa', 
 clinch: 'perdagangan sebenar', 
 used: 'tersedia', 
 buyed: 'boleh dibeli', 
 amount: 'jumlah perdagangan', 
 limitprice: 'harga had', 
 marketprice: 'harga pasaran', 
 forprice: 'berdagangan dengan harga terbaik semasa', 
 errorMoney: 'baki tersedia tidak mencukupi', 
 priceerror: 'sila masukkan harga perintah', 
 numerror: 'sila masukkan kuantiti perintah', 
 moneyerror: 'sila masukkan jumlah perintah', 
 }, 
 assets: { 
 allconvert: 'jumlah aset setara', 
 usenum: 'tersedia', 
 freeze: 'beku', 
 convert: 'setara', 
 tab1: 'aset', 
 tab11: 'jumlah aset setara', 
 tab12: 'aset pilihan setara', 
 tab13: 'aset wang tunai setara', 
 tab14: 'aset kuantitatif setara', 
 tab2: 'pilihan', 
 tab21: 'akaun pilihan', 
 tab3: 'wang tunai', 
 tab31: 'akaun wang tunai', 
 tab4: 'kuantitatif', 
 tab41: 'akaun kuantitatif', 
 tbhead1: 'rekod kewangan', 
 tbhead2: 'rekod pengeluaran', 
 tbhead3: 'rekod isi semula', 
 tbhead4: 'rekod pemindahan', 
 rcdnum: 'kuantiti', 
 rcd: 'rekod', 
 rcdtime: 'masa', 
 rcdstatus: 'status', 
 rcddesc: 'keterangan', 
 rcdaddress: 'alamat isi semula' 
 }, 
 change: { 
 title: 'pemindahan', 
 from: 'dari {name}', 
 to: 'ke {name}', 
 frmtitle: 'kuantiti pemindahan', 
 inputplaceholder: 'sila masukkan kuantiti pemindahan', 
 btntxt: 'pemindahan' 
 }, 
 recharge: { 
 title: 'isi semula', 
 bType: 'mata wang semasa', 
 address: 'alamat isi semula', 
 token: 'bukti pembayaran', 
 tokenplaceholder: 'sila muat naik bukti pembayaran', 
 num: 'kuantiti isi semula', 
 numplaceholder: 'sila masukkan kuantiti', 
 btn: 'hantar untuk semakan', 
 bankname: 'nama bank', 
 bankno: 'no akaun bank', 
 accountname: 'nama akaun penerima', 
 bankaddress: 'alamat bank', 
 bankcode: 'kod pembayaran bank', 
 companyaddress: 'alamat syarikat' 
 }, 
 withdrawal: { 
 title: 'keluarkan', 
 frmtitle1: 'kuantiti', 
 frmplaceholder1: 'kuantiti pengeluaran antara {min} - {max}', 
 frmtitle2: 'kata laluan pengeluaran', 
 frmplaceholder2: 'sila masukkan kata laluan pengeluaran', 
 getnum: 'kuantiti yang diterima', 
 fee: 'yuran', 
 btn: 'keluarkan' 
 }, 
 exchangeb: { 
 title: 'pertukaran', 
 account: 'akaun', 
 btn: 'pertukaran', 
 numerror: 'sila masukkan kuantiti pertukaran' 
 }, 
 option: { 
 title: 'pilihan', 
 typetitle: 'kontrak segundi', 
 listtitle: 'kedudukan', 
 kline: 'garis K', 
 high: 'tinggi', 
 low: 'rendah', 
 nums: 'jumlah 24 jam', 
 time: 'masa', 
 transaction: 'mod perdagangan', 
 quantity: 'kuantiti pembukaan kedudukan', 
 quantityerror: 'sila masukkan kuantiti pembukaan kedudukan', 
 times: 'masa pembukaan kedudukan', 
 times1: 'masa Penyelesaian',
 account: 'baki akaun', 
 buyup: 'beli naik', 
 buydown: 'beli turun', 
 tab1: 'senarai kedudukan', 
 tab2: 'rekod pesanan', 
 num: 'kuantiti', 
 price1: 'harga pembelian', 
 price2: 'harga jual', 
 profitandloss: 'untung rugi dijangka', 
 profitandloss1: 'untung rugi', 
 countdown: 'mengira waktu', 
 waitfinish: 'menunggu penyelesaian', 
 finishing: 'sedang menyelesaikan...', 
 finished: 'telah diselesaikan', 
 order_price: 'harga semasa', 
 order_cycle: 'kitaran', 
 order_type: 'jenis', 
 order_money: 'jumlah wang', 
 order_time: 'membuka kedudukan', 
 order_get: 'keuntungan', 
 order_btn: 'lanjutkan pesanan' 
 }, 
 tradelst: { 
 title: 'perintah saya', 
 tab1: 'perintah', 
 tab2: 'perdagangan selesai', 
 tab3: 'dibatalkan', 
 usdtnum: '' 
 }, 
 loans: {
    repayment: 'Pembayaran kembali',
 title: 'pinjaman bantu', 
 order_tab: 'pesanan pinjaman', 
 pro_tab: 'produk pinjaman', 
 Institution: 'institusi pemberi pinjaman', 
 Amount: 'jumlah', 
 DailyInterest: 'kadar faedah harian', 
 RepaymentPeriod: 'tempoh pembayaran balik', 
 Application: 'memohon pinjaman', 
 orderno: 'no pesanan', 
 AllInterest: 'jumlah faedah', 
 RepaymentDate: 'tarikh pembayaran balik', 
 RepaymentMethod: 'kaedah pembayaran balik', 
 Onetime: 'sekali', 
 Expected_loan_amount: 'jumlah pinjaman yang diharapkan', 
 Expected_loan_amounterror: 'jumlah pinjaman antara {min} - {max}', 
 imgplaceholdr: 'pinjaman berasaskan kredit (pastikan gambar jelas dan jelas dilihat)', 
 icon1: 'muat naik gambar IC hadapan', 
 icon2: 'muat naik gambar IC belakang', 
 icon3: 'muat naik gambar memegang IC', 
 status1: 'sedang memohon', 
 status2: 'permohonan diluluskan', 
 status3: 'permohonan gagal', 
 }, 
 lockming: { 
 title: 'penambitan penjara untuk menambang', 
 order_tab: 'pesanan mesin penambang', 
 pro_tab: 'pasaran mesin penambang', 
 locknum: 'kuantiti penambitan minimum', 
 getforday: 'kadar pengembalian/hari', 
 days: 'hari', 
 estimation: 'anggaran pengembalian', 
 real: 'pengembalian sebenar', 
 balance: 'baki dompet', 
 nums: 'kuantiti penambitan', 
 tolockming: 'penambitan', 
 stime: 'masa bermula', 
 etime: 'masa berakhir', 
 }, 
 transfer: { 
 title: 'pemindahan akaun', 
 searchtxt: 'sila masukkan no akaun pihak lain', 
 ReceivingAccount: 'maklumat akaun penerima', 
 toaccount: 'akaun', 
 confirmtxt: 'sila klik untuk mengesahkan akaun penerima', 
 confirmedtxt: 'akaun penerima telah disahkan', 
 numtxt: 'kuantiti pemindahan', 
 numerror: 'sila masukkan kuantiti pemindahan', 
 fee: 'yuran pemindahan dalaman dilupuskan', 
 ArrivalTime: 'masa tiba', 
 Immediately: 'tiba segera', 
 realnum: 'kuantiti yang sebenarnya tiba', 
 btn: 'sahkan pemindahan', 
 transfering: 'sedang memindahkan', 
 orderNo: 'no pesanan', 
 stime: 'masa pemindahan', 
 etime: 'masa tiba', 
 receiving: 'akaun penerima', 
 type: 'mata wang', 
 num: 'kuantiti pemindahan', 
 arrivalnum: 'kuantiti yang diterima' 
 }, 
staking: { 
 title: 'Jaminan', 
 record: 'Rekod', 
 getforyear: 'Pendapatan tahunan rujukan', 
 time: 'Tempoh pelaburan', 
 snum: 'Kuantiti permulaan', 
 snumerror: 'Sila masukkan kuantiti permulaan', 
 snumerror1: 'Kuantiti permulaan tidak boleh kurang daripada {num}', 
 join: 'Sertai sekarang', 
 opentime: 'Masa membuka kedudukan', 
 money: 'Jumlah wang yang dilaburkan', 
 days: 'Kitaran', 
 recordget: 'Pendapatan tahunan', 
 gets: 'Pendapatan', 
 stime: 'Tarikh bermula', 
 etiem: 'Tarikh berakhir', 
 redeemStaking: 'Tebus', 
 status0: 'Dalam jaminan', 
 status1: 'Pesanan tamat', 
 status2: 'Pesanan ditebus', 
}, 
bank: { 
 title: 'Mengikat kad bank', 
 bankName: 'Nama bank', 
 bankNameError: 'Sila masukkan nama bank', 
 usrName: 'Pemegang kad', 
 usrNameError: 'Sila masukkan pemegang kad', 
 cardCode: 'Nombor kad bank', 
 cardCodeError: 'Sila masukkan nombor kad bank', 
 towallet: 'Keluarkan ke dompet', 
 tobank: 'Keluarkan ke kad bank', 
 sendcode: 'Hantar kod pengesahan', 
 sended: '{num} saat kemudian hantar semula', 
 verify_code: 'Sila masukkan kod pengesahan e-mel' 
}
}
